import React, { useRef, useEffect, useState, Fragment } from 'react';
import moment from 'moment';
import cn from 'classnames';
import { generateDayTasks, sortDayTasks } from '../utils';
import DayTaskWrapper from './DayTaskWrapper';
import Cells from './Cells';
import { states } from '../../../constants/states';
import useCellClickHandlers from '../../../hooks/useCellClickHandlers';
import { containerIds } from '../../../constants/containerIds';
import Task from '../../Task/Task';
import { cellHeight } from '../../../constants/common';
import DaylongMoreBtn from '../../DaylongMoreBtn/DaylongMoreBtn';
import useMoreButtonClick from '../../../hooks/useMoreButtonClick';
import { useCalendarState } from '../../../context/CalendarContext';
import commonStyles from '../../../Calendar.module.scss';
import styles from '../CalendarGrid.module.scss';
import { modes } from '../../../constants/modes';
import { views } from '../../../constants/views';

const DAYLONG_TASKS_DATA = {
  width: 240,
  gap: 10,
  row: 2,
  defaultVisibleCount: 7,
};

const DayView = ({ rowCount }) => {
  const { calendarSheet, calendarData, state, localTask, view, mode, showOwner } =
    useCalendarState();

  const [taskWrapperWidth, setTaskWrapperWidth] = useState();
  const [visibleDaylongTaskCount, setVisibleDaylongTaskCount] = useState(
    DAYLONG_TASKS_DATA.defaultVisibleCount
  );
  const [tasks, setTasks] = useState([]);
  const [daylongTasks, setDaylongTasks] = useState([]);

  const dayTasksContainerRef = useRef();

  const { handleDayCellClick } = useCellClickHandlers();

  const handleMoreButtonClick = useMoreButtonClick();

  // set tasks and daylongTasks
  useEffect(() => {
    let newTasks = [];
    let newDaylongTasks = [];

    if (calendarData.length > 0) {
      const [item] = calendarData;

      const taskArray =
        localTask && item.day.isSame(moment(localTask.fromDate), 'day')
          ? item.tasks.concat(localTask)
          : item.tasks;

      const { tasks } = generateDayTasks(taskArray);

      newTasks = tasks;
      newDaylongTasks = item.daylongTasks.filter((task) => task.visible);
    }

    setTasks(newTasks);
    setDaylongTasks(newDaylongTasks);
  }, [calendarData, localTask]);

  // set task wrapper width and visible daylong task count
  useEffect(() => {
    const setWidth = () => {
      if (dayTasksContainerRef.current) {
        const width = dayTasksContainerRef.current.clientWidth;

        const { width: taskWidth, gap, row } = DAYLONG_TASKS_DATA;

        const daylongTaskCount =
          Math.floor(width / (taskWidth + gap)) * row - 1;

        setTaskWrapperWidth(width);
        setVisibleDaylongTaskCount(daylongTaskCount);
      }
    };

    setWidth();

    window.addEventListener('resize', setWidth);

    return () => {
      window.removeEventListener('resize', setWidth);
      setVisibleDaylongTaskCount(DAYLONG_TASKS_DATA.defaultVisibleCount);
    };
  }, [dayTasksContainerRef.current]);

  const heightTask = showOwner && mode === modes.calendar && view === views.day;

  return (
    <Fragment>
      <div
        id={containerIds.daylongTasksDay}
        className={cn(
          styles.daylongContainer,
          styles.borderBottom,
          styles.dayViewDaylongContainer
        )}
        style={{
          gridColumn: '2/3',
          top: '104px',
        }}
      >
        {daylongTasks.slice(0, visibleDaylongTaskCount).map((task) => {
          return (
            <Task
              key={task.id}
              hideWorkers
              task={task}
              rootClassName={cn(commonStyles[`checkbox-${task.index}`], 'task')}
              style={{
                maxHeight: '56px',
                width: `${DAYLONG_TASKS_DATA.width}px`,
              }}
              getPopupContainer={() =>
                document.getElementById(containerIds.daylongTasksDay)
              }
            />
          );
        })}
        {daylongTasks.length > visibleDaylongTaskCount && (
          <DaylongMoreBtn
            style={{ width: `${DAYLONG_TASKS_DATA.width}px` }}
            count={daylongTasks.length - visibleDaylongTaskCount}
            onClick={
              calendarData.length > 0
                ? () => handleMoreButtonClick(calendarData[0])
                : undefined
            }
          />
        )}
      </div>
      <div
        className={styles.weekColumn}
        style={{ gridColumn: '2/-1', position: 'relative' }}
      >
        <Cells
          rowCount={rowCount}
          className={styles.cellWrapper}
          style={{ height: `${cellHeight(heightTask, calendarData)}px` }}
          onClick={
            state === states.addTask
              ? (_e, index) => handleDayCellClick(index)
              : undefined
          }
        />
        <div ref={dayTasksContainerRef} className={styles.dayTasksContainer}>
          {tasks.map((tasksArr) => {
            return tasksArr
              .sort(sortDayTasks)
              .map((task, taskIndex) => (
                <DayTaskWrapper
                  key={task.id || task.requestId}
                  day={calendarSheet.clone()}
                  task={task}
                  taskIndex={taskIndex}
                  taskCount={tasksArr.length}
                  taskWrapperWidth={taskWrapperWidth}
                />
              ));
          })}
        </div>
      </div>
    </Fragment>
  );
};

export default DayView;
